const Kategoriya3412 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
                <h3 className="text-center text-primary">
                    3-sinf 4-chorak<br />
                    Mavzu: Son, fe'l<br />
                    "Oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
                </h3>
                <b>1-mashq. Nuqtalar o'rniga harflar qo'ying, ot va fe'llarni jadvalga yozing.</b><br />
                <i>Ta'limiy maqsad:</i> O'quvchilarning imloviy ko'nikmalarini rivojlantirish.<br />
                <i>Mashg'ulot davomiyligi:</i> 5-6 daqiqa<br />
                <br />
                Lov…llamoq, musht…mzo'r, non…shta, hazil-huz…l, kund…z, dup…rlamoq, bo'yintur…q, gumb…rlamoq, suy…mli, uz…n, uch…rmoq, yug…rmoq, tush…rmoq, o'k…rmoq, uv…llamoq, uz…m, xamirt…rush.
                <table border="1" width="100%" height="250px">
                    <tr>
                        <td>Ot</td>
                        <td>Fe'l</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
                <p><b>2-mashq. Berilgan so'zlardagi xatoliklarni to'g'rilang.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning imloviy ko'nikmalarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>Badiy - badiiy</p>
                <p>Inshoat - _________________</p>
                <p>Mutasib - _________________</p>
                <p>Tabiy - ___________________</p>
                <p>Tassurot - _________________</p>
                <p>Zopark - __________________</p>
                <p><b>3-mashq. FDM usulidan foydalanib, berilgan matnni izohlang.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning bog'lanishli nutq haqidagi ko'nikmalarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>Otlar o'zbek tili leksikasining katta qismini tashkil qiladi. Otlar bilan ko'proq tanishish, yangi otlarning ma'nolarini o'zlashtirib borish boshlang'ich sinf o'quvchiariga og'zaki va yozma nutqda yaqindan yordam beradi.</p>
                <p>Fikr: ___________________________________________________________</p>
                <p>Dalil: _________________________________________________________</p>
                <p>Misol: ________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3412;